import ModelUtil from '@leverege/model-util';
import RolloverTypeModel from "./RolloverTypeModel.js";
const TYPE = 'detail.Rollover';

// separate the details and the layout for them so
// i can reuse the detail part

function create() {
  return {
    type: TYPE,
    visible: true,
    margin: '24px',
    placement: 'bottom-left',
    atPointPlacement: 'top',
    types: {}
  };
}
const mod = {
  TYPE,
  create,
  getType,
  addType,
  needsPointPosition,
  getPlacementForType,
  getPointPlacementForType,
  ...ModelUtil.createAllValue('visible'),
  ...ModelUtil.createAllValue('placement'),
  ...ModelUtil.createAllValue('atPointPlacement'),
  ...ModelUtil.createAllValue('margin'),
  ...ModelUtil.createAllMap('types', 'type', 'types')
  // ...ModelUtil.createAllArray( 'details', 'Detail', 'Details' )
};
function addType(model, type) {
  if (type == null) {
    throw new Error('RolloverModel.addType(): type cannot be null');
  }
  return mod.types().set(model, type, RolloverTypeModel.create(type));
}
function getType(model, type) {
  return model?.types?.[type];
}
function needsPointPosition(model, type) {
  return getPointPlacementForType(model, type) != null;
}
function getPlacementForType(model, type) {
  if (model == null) {
    return 'bottom-left';
  }
  if (type && model.types?.[type]) {
    const m = model.types[type];
    return m.placement || model.placement || 'bottom-left';
  }
  return model.placement || 'bottom-left';
}
function getPointPlacementForType(model, type) {
  if (model == null) {
    return null;
  }
  if (type && model.types?.[type]) {
    const m = model.types[type];
    if (m.atPointPlacement === 'none') {
      return null;
    }
    return m.atPointPlacement || model.atPointPlacement || null;
  }
  return model.atPointPlacement || null;
}
export default mod;